<script lang="ts">
	import { appName } from "../../../core/schema/appName";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import { showHeaderStore } from "../stores/showHeaderStore.js";
	import logo from "../../../core/assets/jamujam-logo.svg";
	import LanguagePicker from "./LanguagePicker.svelte";
	import Link from "./Link.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "../templates/Homepage.translations.json";
	import { getTenant } from "../contexts/tenantContextKey";
	import { getGlobalSettings } from "../getGlobalSettings";
	import { getSignUpUrl } from "../utils/getSignUpUrl";

	const translate = getTranslate(translations);

	let scrollPosition = 0;
	let scrollFromLastDirectionChange = 0;
	const scrollTolerance = 25;
	let showHeader = true;

	function onScroll(event: UIEvent & { currentTarget: EventTarget & Window }): void {
		const { scrollY } = event.currentTarget;
		const newScrollPosition = Math.max(scrollY, 0);
		const oldDirection = scrollFromLastDirectionChange < 0 ? "up" : "down";
		const newDirection = newScrollPosition > scrollPosition ? "down" : "up";

		if (oldDirection !== newDirection) {
			scrollFromLastDirectionChange = 0;
		}
		scrollFromLastDirectionChange += newScrollPosition - scrollPosition;

		scrollPosition = newScrollPosition;

		if (Math.abs(scrollFromLastDirectionChange) > scrollTolerance) {
			showHeader = scrollFromLastDirectionChange < 0;
		}
	}

	const { locale } = getTenant();
	const { WEB_URL } = getGlobalSettings();
	const canonical = `${WEB_URL}/${locale}`;
</script>

<svelte:window on:scroll={onScroll} />

<header
	class="border-b-1 fixed left-0 right-0 top-0 z-50 h-20 w-full border-solid bg-white py-3 grayscale-[1%] backdrop-blur-md transition-[border,transform,padding] duration-300 lg:h-auto lg:py-0"
	class:border-gray-200={scrollPosition > 0}
	class:border-transparent={scrollPosition <= 0}
	class:lg:pt-16={scrollPosition <= 64}
	class:-translate-y-full={!showHeader && !$showHeaderStore}
	class:translate-y-0={showHeader || $showHeaderStore}
>
	<div class="container relative h-full">
		<div
			class="flex h-full w-full grid-cols-[1fr,auto,1fr] items-center justify-between gap-4 lg:gap-2 lg:px-8 lg:py-1 xl:gap-12"
		>
			<a href={canonical} class="h-auto w-[7.5rem] lg:mx-auto lg:w-auto">
				<StaticPicture
					alt="Logo {appName}"
					image={logo}
					imgClass="w-full h-auto md:w-[203px] h-[79px]"
					loading="eager"
					width={203}
					height={79}
				/>
			</a>
			<div class="flex items-center justify-end gap-4 lg:absolute lg:right-0">
				<Link asButton href={getSignUpUrl(WEB_URL)}>
					<span class="max-lg:text-3xs text-2xs hidden lg:block">{translate("tryApp")}</span>
					<span class="max-lg:text-3xs text-2xs block lg:hidden">{translate("begin")}</span>
				</Link>
				<LanguagePicker />
			</div>
		</div>
	</div>
</header>
